import { render, staticRenderFns } from "./DesktopPager.vue?vue&type=template&id=d827f81e&scoped=true&"
import script from "./DesktopPager.vue?vue&type=script&lang=ts&"
export * from "./DesktopPager.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopPager.vue?vue&type=style&index=0&id=d827f81e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827f81e",
  null
  
)

export default component.exports